<template>
  <div class="as-seen-in" aria-label="As seen in">
    <p class="as-seen-label">As seen in</p>
    <PressLogoStrip />
  </div>
</template>

<script>
import PressLogoStrip from '@/components/PressLogoStrip.vue';

export default {
  name: 'AsSeenIn',
  components: { PressLogoStrip },
};
</script>

<style scoped>
.as-seen-in {
  margin: 18px auto 28px;
  max-width: 920px;
  text-align: center;
}

.as-seen-label {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  /* #58595B (brand $carbon) — 7.6:1 on white. */
  color: #58595B;
  margin: 0 0 10px;
}
</style>
